export default "__VITE_ASSET__564d1435__"